import React from 'react';
import {sourcePaletteEntry} from '../lib/storyContext';
import {buildStoryOverview} from '../lib/storyOverview';
import {formatTime} from '../lib/editModel';

/** Read-only Assembly composition and pacing beside the source video.
 * Passage clicks navigate to their editable Assembly rows.
 */
export default function StoryOverview({blocks=[],sourceIds=[],sourceName=()=>'',selectedPassageId,onJump,hidden=false}){
 const {seconds,composition,segments}=buildStoryOverview(blocks,sourceIds);
 const longest=segments.reduce((best,segment)=>!best||segment.duration>best.duration?segment:best,null);
 const average=segments.length?seconds/segments.length:0;
 const percentage=share=>Math.round(share*100);
 const label=id=>sourceName(id)||'Interview';
 return <aside className="story-overview" id="paper-story-overview-panel" aria-label="Assembly overview" hidden={hidden}>
   <h4 className="story-overview-title">Assembly Overview</h4>
   <div className="story-overview-section">
     <div className="story-overview-section-head">
       <strong>Interview composition</strong>
       <small>{formatTime(seconds)} total</small>
     </div>
     {composition.length?<>
       <div className="story-overview-composition-track" role="img"
         aria-label={'Interview contributions by footage duration: '+composition.map(item=>label(item.id)+' '+percentage(item.share)+' percent').join(', ')}>
         {composition.map(item=><span key={item.id}
           title={label(item.id)+' · '+formatTime(item.seconds)+' · '+percentage(item.share)+'%'}
           style={{flexGrow:item.seconds,backgroundColor:sourcePaletteEntry(item.id,sourceIds).colour}}/>)}
       </div>
       <div className="story-overview-legend" aria-label="Interview contribution durations">
         {composition.map(item=><div className="story-overview-legend-row" key={item.id}>
           <span className="story-overview-key" style={{backgroundColor:sourcePaletteEntry(item.id,sourceIds).colour}} aria-hidden="true"/>
           <span className="story-overview-name" title={label(item.id)}>{label(item.id)}</span>
           <span className="story-overview-time">{formatTime(item.seconds)}</span>
           <span className="story-overview-percentage">{percentage(item.share)}%</span>
         </div>)}
       </div>
     </>:<p className="story-overview-empty">Add passages to see how your interviews contribute to the Assembly.</p>}
   </div>
   <div className="story-overview-section story-overview-pacing">
     <div className="story-overview-section-head">
       <strong>Assembly pacing</strong>
       <small>{segments.length} passages</small>
     </div>
     {segments.length?<div className="story-overview-pacing-track" role="group" aria-label="Jump to a passage in the Assembly">
       {segments.map(segment=><button key={segment.id} type="button"
         className={selectedPassageId===segment.id?'is-selected':''}
         aria-label={'Jump to passage '+(segment.index+1)+' · '+label(segment.sourceId)+' · '+formatTime(segment.duration)+' · '+segment.text.slice(0,90)}
         aria-pressed={selectedPassageId===segment.id}
         title={'Passage '+(segment.index+1)+' · '+label(segment.sourceId)+' · '+formatTime(segment.start)+'–'+formatTime(segment.end)+' · '+segment.text.slice(0,100)}
         style={{flexGrow:segment.duration,backgroundColor:sourcePaletteEntry(segment.sourceId,sourceIds).colour}}
         onClick={()=>onJump?.(segment.id)}
       />)}
     </div>:<div className="story-overview-pacing-empty" aria-hidden="true"/>}
     <div className="story-overview-pacing-times"><span>0:00</span><span>{formatTime(seconds)}</span></div>
     <small className="story-overview-hint">Each colour represents a passage · click to jump</small>
     {!!segments.length&&<div className="story-overview-insights" aria-label="Assembly pacing statistics">
       <span className="story-overview-insight">Average passage <strong>{formatTime(average)}</strong></span>
       {longest&&<button className="story-overview-insight" type="button"
         title={'Jump to longest passage: '+label(longest.sourceId)+' · '+longest.text.slice(0,100)}
         onClick={()=>onJump?.(longest.id)}>
         Longest <strong>{label(longest.sourceId)} · {formatTime(longest.duration)}</strong>
       </button>}
     </div>}
   </div>
 </aside>;
}
